import { Module, getModule, VuexModule, MutationAction, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';
import { FilterRequestType } from '@/entity/common/filters.types'
import {
    IProductsCategoryTitem,
    IProductsCategoryTypes,
    ProductsCategoryAddRequestType,
    ProductsCategoryUpdateRequestType
} from '@/entity/warehouse/Products/Category/Category.types';
import { limitStrLength } from "@/UI/lib/support"
import { ResponseDataType } from '@/form/form.types';
import { PaginationRequestType } from '@/entity/common/pagination.types';
import { prepareFormData } from '@/store/utils/formDataHelper'

/*interface iCategories {
    [index: string]: iCategory;
}*/
export interface iCategory {
    index: number | null;
    name: string;
    fullname: string;
}

@Module({
    namespaced: true,
    name: 'ProductsCategories',
    store,
    dynamic: true
})
class ProductsCategoriesModule extends VuexModule {
    public productsCategories:IProductsCategoryTypes[] | null = null
    public dataCategories:iCategory[] = []
    public dataCategory: IProductsCategoryTypes | null = null

    @MutationAction
    async fetchAll(data?: FilterRequestType): Promise<{ productsCategories:IProductsCategoryTypes[]}>{
        /*const formData = new FormData();
        if (data) {
            if (data.filter) {
                for(const field in data.filter){
                    Object.keys(data.filter).forEach(field => formData.append('filter[' + field + ']', data.filter[field].toString()));
                }
            } else formData.delete('filter');
        }*/
        const productsCategories = await store.$repository.products_categories.fetchAll(prepareFormData(data));
        return { productsCategories }
    }

    @MutationAction
    async fetchData(data: PaginationRequestType):Promise<{dataCategory:IProductsCategoryTypes}>{
        const dataCategory = await store.$repository.products_categories.fetchData(data)
        return { dataCategory }
    }

    @Action({rawError: true})
    async create(data: ProductsCategoryAddRequestType): Promise<ResponseDataType> {
       return await store.$repository.products_categories.create(data);
    }

    @Action({rawError: true})
    async update(data: ProductsCategoryUpdateRequestType): Promise<ResponseDataType> {
       return await  store.$repository.products_categories.update(data)
    }

    @Action({rawError: true})
    async delete(id: number): Promise<ResponseDataType> {
        return await store.$repository.products_categories.delete({id: id});
    }

    @Mutation
    async fetchCategories(){
        //this.dataCategories = []
        console.log('prepare categories -')
        if (this.productsCategories) {
            this.dataCategories.length = 0
            this.productsCategories.forEach((data:IProductsCategoryTitem, index:number) => {
                this.dataCategories[index] = {index:data.id, name:data.name, fullname:data.name } as iCategory
                // name:limitStrLength(data.name,15)
            })
        }
    }
}
export const ProductsCategoriesStore = getModule(ProductsCategoriesModule)